import { useAppConstantsContext } from '@ltvco/refresh-lib/ctx';
import { Text } from '@ltvco/refresh-lib/theme';
import FiberNewIcon from '@mui/icons-material/FiberNew';

import {
  BannerContent,
  BannerCta,
  BannerHeaderRow,
  BannerIllustration,
  BannerRoot,
} from './components';

export type NeighborhoodInsightsBannerProps = {
  onExploreClick: () => void;
};

export function NeighborhoodInsightsBanner({
  onExploreClick,
}: NeighborhoodInsightsBannerProps) {
  const { images } = useAppConstantsContext();
  const { imgNeighborhoodInsightsBanner } = images as {
    imgNeighborhoodInsightsBanner?: string;
  };

  return (
    <BannerRoot>
      <BannerContent>
        <BannerHeaderRow>
          <FiberNewIcon
            aria-hidden
            sx={{ color: 'primary.main', fontSize: 34 }}
          />
          <Text variant="h3" mb={0}>
            What's this neighborhood really like?
          </Text>
        </BannerHeaderRow>
        <Text variant="body1" mb={0}>
          View insights on home values, safety, and everyday life.
        </Text>
        <BannerCta variant="outlined" color="primary" onClick={onExploreClick}>
          Explore Neighborhood
        </BannerCta>
      </BannerContent>
      <BannerIllustration aria-hidden>
        <img
          src={imgNeighborhoodInsightsBanner}
          alt="Neighborhood Insights Banner"
        />
      </BannerIllustration>
    </BannerRoot>
  );
}
